import { whyChooseItems } from "@/mocks/categories";

const whyImages = [
  "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20colorful%20sneakers%20displayed%20neatly%20on%20a%20light%20beige%20surface%2C%20soft%20natural%20window%20lighting%2C%20warm%20cream%20tones%2C%20organized%20retail%20catalog%20aesthetic%2C%20minimalist%20composition%2C%20fashion%20footwear%20display%2C%20subtle%20shadows%2C%20no%20text%20no%20logos&width=600&height=400&seq=why-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Professional%20flat%20lay%20photography%20of%20fashion%20items%20with%20a%20magnifying%20glass%20concept%20on%20light%20cream%20linen%2C%20soft%20diffused%20daylight%2C%20warm%20neutral%20beige%20tones%2C%20editorial%20catalog%20style%2C%20research%20and%20inspection%20theme%2C%20organized%20clean%20layout%2C%20no%20text%20no%20logos&width=600&height=400&seq=why-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20an%20open%20notebook%20and%20fashion%20accessories%20arranged%20on%20warm%20sand%20colored%20surface%2C%20soft%20natural%20morning%20light%2C%20cream%20and%20ivory%20tones%2C%20educational%20learning%20aesthetic%2C%20organized%20structured%20composition%2C%20subtle%20texture%20details%2C%20no%20text%20no%20logos%20no%20people&width=600&height=400&seq=why-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20stylish%20backpack%20and%20travel%20accessories%20with%20a%20calculator%20nearby%20on%20light%20beige%20surface%2C%20soft%20natural%20lighting%2C%20warm%20oatmeal%20tones%2C%20budget%20planning%20and%20shopping%20optimization%20theme%2C%20organized%20retail%20catalog%20aesthetic%2C%20no%20text%20no%20logos&width=600&height=400&seq=why-04&orientation=landscape",
];

export default function WhyChooseSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            Why Users Choose Our Sugargoo Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            We provide the most comprehensive, regularly updated Sugargoo Spreadsheet resources designed to make international shopping effortless and enjoyable.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyChooseItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-200 hover:border-primary-300"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={whyImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h4 className="font-semibold text-sm text-foreground-900 mb-2">{item.title}</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}